// extracted by mini-css-extract-plugin
module.exports = {"login-form":"styles_login-form__koNDT","login-form-button":"styles_login-form-button__2feMu"};